import { Empty } from "antd";
import { CSSProperties, FC } from "react";
import { useTranslation } from "react-i18next";

interface CEmptyProps {
  text?: string;
  className?: string;
  style?: CSSProperties;
}

export const CEmpty: FC<CEmptyProps> = ({ text, className, style }) => {
  const { t } = useTranslation("message");
  return (
    <Empty
      style={style}
      imageStyle={{ height: 60 }}
      description={text || t("no-content", { ns: "message" })}
      className={`p-5 ${className}`}
    />
  );
};
